import React from 'react';
import {MenuItem} from 'ui';
import BaseProjectRow from './BaseProjectRow';
import { getProjectDisplayName } from './projectRowUtils';
import { useIsProjectOwner } from 'hooks/users/useIsProjectOwner';
import { useUnarchiveProject } from 'hooks/projects/mutations';
import { useIsFetching } from '@tanstack/react-query';
import { projectKeys } from 'hooks/projects/queries';

function ArchivedProjectRow(props) {
  const unarchiveMutation = useUnarchiveProject();
  const isFetchingProjects = useIsFetching({ queryKey: projectKeys.all });
  
  if (!props.project || !props.project.id) return <div></div>;
  
  const isOwner = useIsProjectOwner(props.project);
  
  // Only show archived projects for owners
  if (!isOwner) return <div> </div>;

  const displayName = getProjectDisplayName(props.project.name);
  const isUnarchiving = unarchiveMutation.isPending || (unarchiveMutation.isSuccess && isFetchingProjects > 0);

  const unarchiveProject = (e, projectId) => {
    e.preventDefault();
    unarchiveMutation.mutate(projectId, {
      onError: () => {
        props.errorArchivingProject(false);
      }
    });
  };
  
  // Archived projects show plain text (no link)
  const projectNameContent = displayName;

  // Menu items specific to archived projects
  const menuItems = (
    <>
      <MenuItem
        eventKey="2"
        onClick={(e)=>unarchiveProject(e, props.project.id)}
        disabled={isUnarchiving}
      >
        {isUnarchiving ? 'Unarchiving...' : 'Unarchive Project'}
      </MenuItem>
    </>
  );

  return (
    <BaseProjectRow
      project={props.project}
      onHide={props.onHide}
      projectNameContent={projectNameContent}
      menuItems={menuItems}
    />
  );
}

export default ArchivedProjectRow;